/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Visibility_VisibleInputs */



/**
* | output |
* | --- |
* | "Visible" |
*
* @param {Style_Guide_Manager_Visibility_VisibleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_visibility_visible = /** @type {((inputs?: Style_Guide_Manager_Visibility_VisibleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Visibility_VisibleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Visible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sichtbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видимый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Visible")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("可见的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("見える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्यमान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visível")
	return /** @type {LocalizedString} */ ("Visible")
});